import { useMemo } from 'react'
import { Stepper, Step } from 'react-form-stepper'
import { FaCheck } from 'react-icons/fa'
import { GrClose } from 'react-icons/gr'
import Tooltip from '@mui/material/Tooltip'

const UniversitiesStepper = ({ universities, result }) => {
  const sortedData = useMemo(() => {
    const entries = Object.entries(universities ?? [])
    entries.sort((a, b) => a[1] - b[1])
    return Object.fromEntries(entries)
  }, [universities])

  const steps = useMemo(() => {
    return Object?.keys(sortedData).map((key, index) => {
      const completed = result >= sortedData[key]
      return (
        <Tooltip key={`step-${index}`} title={sortedData[key]}>
          <>
            <Step
              disabled={false}
              completed={completed}
              styleConfig={{
                activeTextColor: 'white',
                activeBgColor: '#808080',
                completedBgColor: 'rgb(0, 217, 178)',
                completedTextColor: 'white',
                inactiveBgColor: 'red',
                inactiveTextColor: 'white',
                size: 40,
                circleFontSize: 15,
                labelFontSize: 14,
                borderRadius: '50%',
                fontWeight: 'bold',
              }}
              label={
                <div className="flex flex-col">
                  <div>{key}</div>
                  <div>{sortedData[key]}</div>
                </div>
              }
            >
              <div
                style={{
                  fontWeight: 'bolder',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {result >= sortedData[key] ? <FaCheck /> : <GrClose />}
              </div>
            </Step>
          </>
        </Tooltip>
      )
    })
  }, [result, sortedData])

  return <Stepper>{steps}</Stepper>
}

export default UniversitiesStepper
